import { render, staticRenderFns } from "./FormToPeople.vue?vue&type=template&id=4ca42ec1&scoped=true&"
import script from "./FormToPeople.vue?vue&type=script&lang=js&"
export * from "./FormToPeople.vue?vue&type=script&lang=js&"
import style0 from "./FormToPeople.vue?vue&type=style&index=0&id=4ca42ec1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca42ec1",
  null
  
)

export default component.exports